/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSON, FxIdApplicationDataConnectionsGetDataCommandToJSON, } from '../models/index';
/**
 *
 */
export class DataConnectionsApi extends runtime.BaseAPI {
    /**
     * https://youtrack.fxgam.es/issue/FL-469/Realizaciya-otobrazheniya-polzovatelskih-rejtingov-v-lonchere#focus=Comments-4-225348.0-0
     */
    async fxIdWebFeaturesDataConnectionsGetDataEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationDataConnectionsGetDataCommand'] == null) {
            throw new runtime.RequiredError('fxIdApplicationDataConnectionsGetDataCommand', 'Required parameter "fxIdApplicationDataConnectionsGetDataCommand" was null or undefined when calling fxIdWebFeaturesDataConnectionsGetDataEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/data-connections/get`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationDataConnectionsGetDataCommandToJSON(requestParameters['fxIdApplicationDataConnectionsGetDataCommand']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSON(jsonValue));
    }
    /**
     * https://youtrack.fxgam.es/issue/FL-469/Realizaciya-otobrazheniya-polzovatelskih-rejtingov-v-lonchere#focus=Comments-4-225348.0-0
     */
    async fxIdWebFeaturesDataConnectionsGetDataEndpoint(fxIdApplicationDataConnectionsGetDataCommand, initOverrides) {
        const response = await this.fxIdWebFeaturesDataConnectionsGetDataEndpointRaw({ fxIdApplicationDataConnectionsGetDataCommand: fxIdApplicationDataConnectionsGetDataCommand }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=DataConnectionsApi.js.map